import React from "react";
import UstodaniMukadamachiMahiti from './UstodaniMukadamachiMahiti.jsx';
import UsTodKamgaranchiMahiti from './UsTodKamgaranchiMahiti.jsx';
import TransportInformation from './TransportInformation.jsx';
import { withRouter } from 'react-router-dom';
var axios = require('axios');
var constants = require("../constants/constants");
var trstyle = { 'font-size': '16px' }
class CardDetail extends React.Component {
  constructor(props) {
    super()
    this.state = {
      isMukadamInfo: false,
      isKamgarInfo: false,
      isKamgarCount: false,
      isVehicleInfo: false,
      editMukadamData: null,
      editKamgarData: null,
      editVehicleData: false,
      isEditCall: false,
      Status: false,
    }
  }

  VehicleInfo(e) {
    this.setState({
      isVehicleInfo: true
    });

  }

  MukadamInfo(e) {
    this.setState({
      isMukadamInfo: true
    });
  }

  KamgarInfo(e) {
    this.setState({
      isKamgarInfo: true
    });
  }

  KamgarCount(e, MukadamId, CompanyId) {
    this.setState({
      isKamgarCount: true
    });
    this.props.history.push({
      pathname: '/KamgarInformation',
      MukadamId: MukadamId,
      CompanyId: CompanyId,
    })
  }

  editVehicleInfo(e, editVehicleData) {
    e.preventDefault();
    this.setState({
      editVehicleData: editVehicleData
    });
    this.props.history.push({
      pathname: '/TransportInformation',
      editVehicleData: editVehicleData,
      isEditCall: true
    })
  }

  editMukadamInfo(e, editMukadamData) {
    e.preventDefault();
    this.setState({
      editMukadamData: editMukadamData
    });
    this.props.history.push({
      pathname: '/UstodaniMukadamachiMahiti',
      editMukadamData: editMukadamData,
      isEditCall: true
    })
  }

  BlackMukadam(e, MukadamId, CompanyId) {
    e.preventDefault();
    this.setState({
      Status: 'Y'
    })
    this.props.history.push({
      pathname: '/BlakListMukadamReason',
      MukadamId: MukadamId,

    })
  }

  BlackKamgar(e, WorkarId, CompanyId) {
    e.preventDefault();
    this.props.history.push({
      pathname: '/BlakListKamgarReason',
      WorkarId: WorkarId,
    })
  }

  editkamgarInfo(e, editKamgarData, MukadamId) {
    e.preventDefault();
    this.setState({
      editKamgarData: editKamgarData
    });
    this.props.history.push({
      pathname: '/UsTodKamgaranchiMahiti',
      editKamgarData: editKamgarData,
      MukadamId: MukadamId,
      isEditCall: true
    })
  }

  render() {
    let currentComponent = this;
    return (
      <div>
        {this.props.mukadam ?
          <div style={{ trstyle }} className="card">
            <h4 style={trstyle} ><b> मुकादमाचे नाव  : &nbsp;&nbsp;</b><b style={{ 'color': '#3700B3' }}>{this.props.Values.fullname}</b></h4>
            <h4 style={trstyle}><b>मोबाईल नंबर :</b><b style={{ 'color': '#3700B3' }}> {this.props.Values.ContactNo} </b></h4>
            <h4 style={trstyle}><b>कामगार संख्या : </b>&nbsp;&nbsp;&nbsp;<button type="button"  className="btn btn-primary  btn-flat" onClick={(e) => this.KamgarCount(e, this.props.Values.MukadamId)}>{this.props.Values.count}</button>&nbsp;&nbsp;&nbsp;  </h4>
            <button type="button" class="btn  btn-info btn-flat " style={{ margin: '5px 0px 12px 20px' }} onClick={(e) => { currentComponent.editMukadamInfo(e, this.props.Values, this.props.Values.MukadamId, this.props.Values.CompanyId); currentComponent.MukadamInfo(e) }}>Edit करा </button>
            {this.props.Values.IsBlock == 'Y' ? <button type="button" class="btn  btn-danger btn-flat" style={{ margin: '5px 0px 12px 40px' }} ><b >BlackList केले आहे </b> </button> :
              <button type="button" class="btn  btn-info btn-flat " style={{ margin: '5px 0px 12px 40px' }} onClick={(e) => { currentComponent.BlackMukadam(e, this.props.Values, this.props.Values.MukadamId, this.props.Values.CompanyId) }}><b style={{ 'color': '	#000000' }}>BlackList करा </b> </button>}

          </div>
          : null
        }
        <div>
          {this.state.isMukadamInfo ?
            <UstodaniMukadamachiMahiti editMukadamInfo={this.state.editMukadamData} isEditCall={true} /> :
            null
          }
        </div>
        <div>
          {this.props.worker ?
            <div className="card">
              <h4 style={trstyle}><b>कामगाराचे नाव : </b><b style={{ 'color': '#3700B3' }}>  {this.props.Values.fullname}</b></h4>
              <h4 style={trstyle}><b>मोबाईल नंबर : </b><b style={{ 'color': '#3700B3' }}>  {this.props.Values.ContactNo}</b> </h4>
              <td> <button type="button" class="btn  btn-info btn-flat" style={{margin: '5px 0px 12px 20px' }} onClick={(e) => { { currentComponent.editkamgarInfo(e, this.props.Values) }; currentComponent.KamgarInfo(e) }}>Edit करा </button>
                {this.props.Values.IsBlock == 'Y' ? <button type="button" class="btn  btn-danger btn-flat " style={{ margin: '5px 0px 12px 40px' }} ><b>BlackList केले आहे </b> </button> :
                  <button type="button" class="btn  btn-info btn-flat " style={{ margin: '5px 0px 12px 40px' }} onClick={(e) => { currentComponent.BlackKamgar(e, this.props.Values, this.props.Values.WorkarId, this.props.Values.CompanyId) }}><b style={{ 'color': '	#000000' }}>BlackList करा </b> </button>}</td>
            </div>
            : null
          }
          <div>
            {this.state.isKamgarInfo ?
              <UsTodKamgaranchiMahiti editkamgarInfo={this.state.editKamgarData} isEditCall={true} /> :
              null
            }
          </div>
        </div>
        {/* style={{ 'color': '#1900ff' }} */}
        {this.props.vehicle ?
          <div className="card">
            <h4><b>  वाहनाचा प्रकार :</b><b style={{ 'color': '#3700B3' }}> {this.props.Values.Name}</b></h4>
            <h4> <b>वाहन नंबर :</b><b style={{ 'color': '#3700B3' }}> {this.props.Values.VehicleNo}</b> </h4>
            <h4> <b>पासिंग तारीख :</b><b style={{ 'color': '#3700B3' }}> {new Date(this.props.Values.Passingdate).toDateString()}</b></h4>
            <h4><b> विमा वेधता तारीख :</b><b style={{ 'color': '#3700B3' }}> {new Date(this.props.Values.InsurancceEndDate).toDateString()}</b></h4>
            <h4><b>policy No :</b> <b style={{ 'color': '#3700B3' }}> {this.props.Values.PolicyNo}</b></h4>

            <button type="button" class="btn  btn-info btn-flat" style={{ margin: '5px 0px 12px 210px' }} onClick={(e) => { { currentComponent.editVehicleInfo(e, this.props.Values) }; currentComponent.VehicleInfo(e) }}>Edit करा </button>
          </div>
          : null
        }
        <div>
          {this.state.isVehicleInfo ?
            <TransportInformation editVehicleInfo={this.state.editVehicleData} isEditCall={true} /> :
            null
          }
        </div>
      </div>
    );
  }
}
export default withRouter(CardDetail)


// WEBPACK FOOTER //
// ./src/component/CardDetail.jsx